import React from "react";
import { Route as ReactRoute, Redirect, BrowserRouter } from "react-router-dom";
import qs from "querystring";
import { RouteMap } from "./common/navigation/routeMap";
import { GRANT_CONSENT, RESET_EXPIRED_PASSWORD } from "../reducers/loginReducer";

const redirectAuthActions = {
  [GRANT_CONSENT]: "/grantConsent",
  [RESET_EXPIRED_PASSWORD]: "/resetExpiredPassword",
  TwoFARequired: "/verify2fa",
  RoleSelectionRequired: "/selectRole",
};
// Check whether sub menu are enable
const isSubmenuEnable = (menuItems, mainMenuId, menuId) => {
  const menuItemFound = menuItems.filter(item => item.id === mainMenuId);

  if (menuItemFound.length > 0) {
    const subMenuFound = menuItemFound.filter(itemFound => {
      if (itemFound.children && Array.isArray(itemFound.children)) {
        const child = itemFound.children.filter(obj => obj.id === menuId);

        return child.length > 0 ? child : null;
      }
      return null;
    });

    return subMenuFound.length > 0;
  }

  return false;
};

/**
 * Handle sub menu page redirect
 *
 * menuItems - Contain the menu items
 * redirectPath - Contain the route path
 * MenuComponents - Contain the default route component
 * TODO: reduce bundle size
 */
const handleMenuPageRedirect = (menuItems, redirectPath) => {
  if (!menuItems) {
    return null;
  }

  switch (redirectPath) {
    case RouteMap.FlexBenefitsMain_BenefitsEnrolment: {
      const mainMenuId = "FlexBenefitsMain";
      // Check for enrolment is enable
      if (!isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_BenefitsEnrolment")) {
        //redirect to checkout
        if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_eCommerce")) {
          return <Redirect to={RouteMap.FlexBenefitsMain_eCommerce} push={true} />;
        }
      }
      return null;
    }

    case RouteMap.FlexBenefitsMain_MyBenefits: {
      //FlexBenefitsMain_BenefitsEnrolment will be in FlexBenefitsMain_MyBenefits when personal insurance is enabled.
      const mainMenuId = "FlexBenefitsMain_MyBenefits";
      if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_BenefitsEnrolment")) {
        //redirect to enrolment
        return <Redirect to={RouteMap.FlexBenefitsMain_BenefitsEnrolment} push={true} />;
      } else if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_CheckOut")) {
        return <Redirect to={RouteMap.FlexBenefitsMain_CheckOut} push={true} />;
      } else {
        return <Redirect to={RouteMap.FlexBenefitsMain_BenefitsStatement} push={true} />;
      }
    }

    case RouteMap.FlexBenefitsMain_BenefitsStatement: {
      const mainMenuId = "FlexBenefitsMain_MyBenefits";
      // Check for benefits statement is enable
      if (!isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_BenefitsStatement")) {
        //redirect to my purchased
        if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_MyPurchased")) {
          return <Redirect to={RouteMap.FlexBenefitsMain_MyPurchased} push={true} />;
        }

        //redirect to insurance product statement
        if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_InsuranceStatement")) {
          return <Redirect to={RouteMap.FlexBenefitsMain_InsuranceStatement} push={true} />;
        }

        //redirect to my purchased
        if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_BenefitsDocument")) {
          return <Redirect to={RouteMap.FlexBenefitsMain_BenefitsDocument} push={true} />;
        }
      }

      return null;
    }

    case RouteMap.FlexBenefitsMain_FSAStatement: {
      const mainMenuId = "FlexBenefitsMain_MyClaims";
      // Check for enrolment is enable
      if (!isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_FSAStatement")) {
        //redirect to submit claim
        if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_NewClaims")) {
          return <Redirect to={RouteMap.FlexBenefitsMain_NewClaims} push={true} />;
        }

        // redirect to pending claims
        if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_PendingClaims")) {
          return <Redirect to={RouteMap.FlexBenefitsMain_PendingClaims} push={true} />;
        }

        // redirect to claim history
        if (isSubmenuEnable(menuItems, mainMenuId, "FlexBenefitsMain_FlexClaimProcessedListing")) {
          return <Redirect to={RouteMap.FlexBenefitsMain_FlexClaimProcessedListing} push={true} />;
        }
      }
      return null;
    }

    case RouteMap.HealthAndWellnessMain_HandWDashboard: {
      const mainMenuId = "HealthAndWellnessMain";
      // Check for wellness is enabled
      if (!isSubmenuEnable(menuItems, mainMenuId, "HealthAndWellnessMain_HandWDashboard")) {
        //redirect to life style ageing
        if (isSubmenuEnable(menuItems, mainMenuId, "HealthAndWellnessMain_Aging")) {
          return <Redirect to={RouteMap.HealthAndWellnessMain_Aging} push={true} />;
        }

        // redirect to advance screening
        if (isSubmenuEnable(menuItems, mainMenuId, "HealthAndWellnessMain_ActionPlan")) {
          return <Redirect to={RouteMap.HealthAndWellnessMain_ActionPlan} push={true} />;
        }

        // redirect to activities
        if (isSubmenuEnable(menuItems, mainMenuId, "HealthAndWellnessMain_Activities")) {
          return <Redirect to={RouteMap.HealthAndWellnessMain_Activities} push={true} />;
        }

        // redirect to elibrary
        if (isSubmenuEnable(menuItems, mainMenuId, "HealthAndWellnessMain_eLibrary")) {
          return <Redirect to={RouteMap.HealthAndWellnessMain_eLibrary} push={true} />;
        }
      }
      return null;
    }

    default:
      return null;
  }
};

const Route = ({
  isAuthenticated,
  pendingAuthActions = [],
  hrRoute = false,
  requireAuth = false,
  authAction = null,
  component: Component,
  menuItems,
  hrAdmin,
  employee,
  requirePasswordReset,
  token,
  ...rest
}) => (
  <ReactRoute {...rest}>
    {({ match, ...props }) => {
      const { pathname, search } = props.location;
      const decodeUri = search.substring(1);
      const query = qs.parse(decodeUri);
      const hasPendingAuthActions = pendingAuthActions.length > 0;

      if (
        !requireAuth ||
        (requireAuth &&
          isAuthenticated &&
          ((authAction && pendingAuthActions[0] === authAction) ||
            (!authAction && !hasPendingAuthActions)))
      ) {
        const isHRAdmin = !hrRoute && hrAdmin && !employee;

        // Allow HR admins to log out
        if (isHRAdmin && match.url !== RouteMap.LogOut && !hasPendingAuthActions) {
          if (location.pathname !== RouteMap.Contact) {
            location.href = `${RouteMap.ReportsMain}/?token=${token}`;
            return;
          }
        }

        const redirectPage = handleMenuPageRedirect(menuItems, match.url);
        if (redirectPage) {
          return redirectPage;
        }

        const { go, push, goBack, replace } = props.history;
        const historyProps = { go, push, goBack, replace };

        const MenuComponent = Component; //withRouter(Component);

        return (
          <MenuComponent
            key={location.pathname}
            {...props}
            {...historyProps}
            match={match}
            query={query}
          />
        );
      } else if (requireAuth && !isAuthenticated) {
        return (
          <Redirect
            to={{
              pathname: "/",
              search:
                pathname.length > 1
                  ? `?redirectTo=${encodeURI(pathname)}${encodeURIComponent(search)}`
                  : "",
              state: { from: pathname },
            }}
          />
        );
      } else if (pendingAuthActions.length > 0) {
        return <Redirect to={redirectAuthActions[pendingAuthActions[0]]} push={true} />;
      } else if (pendingAuthActions.length === 0) {
        return <Redirect to="/" push={true} />;
      }
    }}
  </ReactRoute>
);

export default Route;



// WEBPACK FOOTER //
// ./components/Route.jsx